import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import ProfilePage from "./ProfilePage";
import useAuth from "../../state/useAuth";

const ProfileMain: React.FC = () => {



  const info = useAuth()
  // console.log("user", info)
  return (
    <div className="home-page">
      <Sidebar activeTab="Profile" />
      <ProfilePage />
    </div>
  );
};

export default ProfileMain;
